<div
    #trigger
    class="select-overlay"
    tabindex="0"
    [class.select-overlay--expanded]="expanded"
    [class.select-overlay--unselected]="isUnselected"
    [class.select-overlay--disabled]="isDisabled"
    [class.select-overlay--invalid]="invalidAndDirty"
    (click)="toggleExpand(); $event.stopPropagation()"
>
    <select [attr.name]="formControlName" class="select-overlay__native-select" [(ngModel)]="value" tabindex="-1">
        <option *ngIf="isUnselected" [ngValue]="undefined" disabled="true"></option>
        <option *ngFor="let item of listItems" [ngValue]="item.value" [innerHTML]="item.text" [disabled]="item.isDisabled"></option>
    </select>

    <div class="select-overlay__custom-select" [innerHTML]="text"></div>
    <label class="select-overlay__label">{{ label }}</label>
    <div class="select-overlay__arrow"></div>
</div>

<ng-template cdkPortal>
    <div class="select-overlay__option-list-overlay">
        <div
            *ngFor="let item of listItems"
            (click)="selectOption(item, $event)"
            class="select-overlay__option-list__item"
            [class.select-overlay__option-list__item--disabled]="item.isDisabled"
            [class.select-overlay__option-list__item--selected]="item.value === value"
        >
            <div class="select-overlay__option-list__item__text" [innerHTML]="item.text"></div>
            <div class="select-overlay__option-list__item__sub-text" [innerHTML]="item.extraLabelText"></div>
        </div>
    </div>
</ng-template>
